import { z } from 'zod';

export const consentSchema = z.object({
  consent: z.object({
    enabled: z.boolean(),
    /** HTML from the editor; empty means the widget's default notice. */
    text: z.string().max(1000, { error: 'chatSettings:validation.consentLength' }),
    /** Empty means no privacy link. */
    privacyPolicyHandle: z.string().max(120),
    usStateNotice: z.boolean(),
    identifyOnLoad: z.boolean(),
  }),
});

export type ConsentForm = z.infer<typeof consentSchema>;
